import React from "react";
import { GameListContainer } from "../styled_components/containers";
import GameListItem from "../styled_components/GameListItem";
import { Scale } from 'react-scaling';

export default function GameList({ games, selectedGameId, onGameSelect }) {
  return (
    <GameListContainer>

        <div>
          {games.map(game => {
            let { id, image, name, description } = game;
            if (id != 23 && id != 35)
              return (
                <GameListItem
                  key={id}
                  selected={selectedGameId === id}
                  onClick={() => onGameSelect(id)}
                  active={game.playable}
                >
                  <img src={image} alt="logo" />
                  <div>
                    <h4>{description}</h4>
                    <aside>{name}</aside>
                  </div>
                </GameListItem>
              );
          })}
        </div>

    </GameListContainer>
  );
}
